import { Component, HostListener, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';
import { PLATFORM_ID } from '@angular/core';
import { UsersService } from '../../../services/users/users.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.html',
  styleUrls: ['./sidebar.scss'],
  standalone: false,
})
export class SidebarComponent {
  isMobile = false;

  constructor(
    private router: Router,
    public userService: UsersService,
    @Inject(PLATFORM_ID) private platformId: object,
  ) {
    this.updateViewportState();
  }

  @HostListener('window:resize')
  onResize(): void {
    this.updateViewportState();
  }

  private updateViewportState(): void {
    if (!isPlatformBrowser(this.platformId)) return;
    this.isMobile = window.matchMedia('(max-width: 991px)').matches;
  }

  isOperationControlsActive(): boolean {
    return this.router.url.includes('/admin/operation-controls/');
  }
  isSalesActive(): boolean {
    return this.router.url.includes('/admin/sales/');
  }
}
